import Skeleton from "react-loading-skeleton";

export default function DetailSkeleton() {
    return (<>
        <div className="container 2xl:px-14 rounded-md sm:rounded-xl">
            <Skeleton height={500} />
        </div>
        <main className="container mt-11 flex ">
            <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10">
                <Skeleton height={150} count={3} />
            </div>
            <div className="hidden lg:block flex-grow">
                <Skeleton height={300} />
            </div>
        </main>
    </>);
}